import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useLocale } from '../../i18n/locale-context.js';
export function PendingStep(props) {
    const { t } = useLocale();
    return (_jsxs("section", { "aria-labelledby": "pending-heading", "aria-busy": "true", children: [_jsx("h3", { id: "pending-heading", children: props.label }), _jsx("p", { role: "status", children: t('activation.pending.status') })] }));
}
//# sourceMappingURL=pending-step.js.map